import gql from 'graphql-tag'

export const GET_SERVICE_SCHEDULES = gql`
  query ServiceSchedules($filter: ServiceSchedulesFilter) {
    serviceSchedules(filter: $filter) {
      isSuccessful
      message
      status
      serviceSchedules {
        data {
          totalServiceSchedules
          totalServiceSchedulesGroups
          totalNormal
          totalSoon
          totalLate
          totalInProgress
          serviceSchedules {
            serviceId
            forceInProgress
            status
            type
            method
            intervalDistance
            intervalTime
            intervalPeriod
            intervalHourmeter
            intervalRefrigerator
            lastServiceDistance
            lastServiceTime
            method
            reminderDistance
            reminderTime
            reminderPeriod
            reminderHourmeter
            reminderRefrigerator
            service {
              name
              serviceAction {
                action
                serviceActionId
              }
              serviceCategory {
                name
                serviceCategoryId
              }
              serviceId
            }
            serviceOrder {
              serviceOrderId
              code
            }
            ssgroup {
              name
            }
            ssgroupId
            service2Ssgroup {
              serviceId
              ssgroupId
              type
              intervalDistance
              reminderDistance
              intervalTime
              intervalPeriod
              reminderTime
              reminderPeriod
              intervalHourmeter
              reminderHourmeter
              intervalRefrigerator
              reminderRefrigerator
              method
              ssgroup {
                name
                ssgroupId
              }
              service {
                serviceId
                name
              }
            }
            startServiceAtTime
            startServiceAtHourmeter
            startServiceAtDistance
            startServiceAtHourmeter
            startServiceAtRefrigerator
            type
            vehicle {
              id
              imei
              odometer
              hourmeter
              refrigerator
              licensePlate
              vehicleType {
                category
                manufacturer
                model
                type
                icon
              }
            }
            vehicleId
            serviceDistanceDifference
            serviceHourmeterDifference
            serviceRefrigeratorDifference
            serviceTimeDifference {
              years
              months
              days
              isDatePassed
              readableText
            }
            workingHour
            workingDuration
            workshop {
              name
              address
              latLong {
                lat
                long
              }
            }
          }
        }
        pagination {
          endCursor
          page
          show
          startCursor
          total
        }
      }
    }
  }
`

export const GET_SERVICE_SCHEDULES_BY_VEHICLE = gql`
  query ServiceSchedulesByVehicle($filter: ServiceSchedulesByVehicleFilter) {
    serviceSchedulesByVehicle(filter: $filter) {
      isSuccessful
      message
      serviceSchedulesByVehicle {
        data {
          serviceSchedules {
            serviceOrder {
              serviceOrderId
              code
            }
            forceInProgress
            status
            type
            serviceId
            ssgroupId
            vehicleId
            intervalDistance
            intervalPeriod
            intervalTime
            intervalHourmeter
            intervalRefrigerator
            reminderDistance
            reminderTime
            reminderPeriod
            reminderHourmeter
            reminderRefrigerator
            lastServiceDistance
            lastServiceTime
            method
            startServiceAtDistance
            startServiceAtTime
            startServiceAtHourmeter
            startServiceAtRefrigerator
            ssgroup {
              name
              service2Ssgroup {
                serviceId
                intervalTime
                intervalDistance
                intervalPeriod
                intervalHourmeter
              }
            }
            service {
              name
              serviceAction {
                action
                serviceActionId
              }
              serviceCategory {
                serviceCategoryId
                name
              }
            }
          }
          totalInProgress
          totalLate
          totalNormal
          totalServiceSchedules
          totalServiceSchedulesGroups
          totalSoon
          vehicleCategorizedAs
          vehicle {
            odometer
            licensePlate
            id
            hourmeter
            vehicleType {
              category
              manufacturer
              model
              type
              icon
            }
            vehicle2Vgroup {
              vgroupId
              vgroup {
                name
              }
            }
          }
          vehicleId
        }
        aggregate {
          vehiclesAsInProgress
          vehiclesAsLate
          vehiclesAsSoon
          vehiclesAsNormal
        }
        pagination {
          endCursor
          page
          show
          startCursor
          total
        }
      }
    }
  }
`

export const GET_SERVICE_SCHEDULE = gql`
  query ServiceSchedule($filter: ServiceScheduleFilter!) {
    serviceSchedule(filter: $filter) {
      isSuccessful
      message
      status
      serviceSchedule {
        status
        intervalDistance
        intervalHourmeter
        intervalRefrigerator
        intervalTime
        intervalPeriod
        lastServiceDistance
        lastServiceHourmeter
        lastServiceTime
        method
        reminderDistance
        reminderHourmeter
        reminderRefrigerator
        reminderTime
        reminderPeriod
        type
        ssgroup {
          name
          service2Ssgroup {
            serviceId
            ssgroupId
            method
            type
            intervalDistance
            intervalHourmeter
            intervalRefrigerator
            intervalPeriod
            intervalTime
            reminderDistance
            reminderHourmeter
            reminderRefrigerator
            reminderPeriod
            reminderTime
          }
        }
        service2Ssgroup {
          serviceId
          ssgroupId
          type
          intervalDistance
          reminderDistance
          intervalTime
          intervalPeriod
          reminderTime
          reminderPeriod
          intervalHourmeter
          intervalRefrigerator
          reminderHourmeter
          reminderRefrigerator
          method
          ssgroup {
            name
            ssgroupId
          }
          service {
            serviceId
            name
          }
        }
        service {
          name
          serviceAction {
            action
            serviceActionId
          }
          serviceCategory {
            name
            serviceCategoryId
          }
          serviceId
        }
        serviceId
        ssgroupId
        serviceHourmeterDifference
        startServiceAtDistance
        startServiceAtHourmeter
        startServiceAtRefrigerator
        startServiceAtTime
        type
        vehicle {
          id
          hourmeter
          imei
          licensePlate
          vehicleType {
            category
            manufacturer
            model
            type
            icon
          }
        }
        vehicleId
        forceInProgress
      }
    }
  }
`

export const CREATE_SERVICE_SCHEDULE = gql`
  mutation CreateServiceSchedule($input: CreateServiceScheduleInput!) {
    createServiceSchedule(input: $input) {
      createServiceSchedule {
        forceInProgress
        status
        intervalDistance
        intervalTime
        intervalPeriod
        reminderDistance
        reminderTime
        reminderPeriod
        lastServiceDistance
        lastServiceTime
        method
        startServiceAtDistance
        startServiceAtTime
        service {
          serviceId
          name
          serviceAction {
            action
            serviceActionId
          }
          serviceCategory {
            name
            serviceCategoryId
          }
        }
        vehicle {
          id
          imei
          licensePlate
          vehicleType {
            category
            manufacturer
            model
            type
          }
        }
      }
      isSuccessful
      message
      status
    }
  }
`

export const BULK_UPDATE_SERVICE_SCHEDULES = gql`
  mutation UpdateServiceSchedules($input: UpdateServiceSchedulesInput) {
    updateServiceSchedules(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updateServiceSchedules {
        serviceId
      }
    }
  }
`

export const UPDATE_SERVICE_SCHEDULE = gql`
  mutation UpdateServiceSchedule($input: UpdateServiceScheduleInput!) {
    updateServiceSchedule(input: $input) {
      isSuccessful
      message
      status
      updateServiceSchedule {
        forceInProgress
        status
        serviceId
        ssgroupId
        vehicleId
        intervalDistance
        intervalTime
        intervalPeriod
        intervalHourmeter
        reminderDistance
        reminderTime
        reminderPeriod
        reminderHourmeter
        lastServiceDistance
        lastServiceTime
        method
        startServiceAtDistance
        startServiceAtTime
        startServiceAtHourmeter
        service {
          name
          serviceAction {
            action
            serviceActionId
          }
          serviceCategory {
            serviceCategoryId
            name
          }
        }
        vehicle {
          id
          imei
          odometer
          licensePlate
          vehicleType {
            category
            manufacturer
            model
            type
          }
        }
      }
    }
  }
`

export const BULK_UPDATE_SERVICE_SCHEDULE = gql`
  mutation UpdateServiceSchedules($input: UpdateServiceSchedulesInput) {
    updateServiceSchedules(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updateServiceSchedules {
        serviceId
        status
        forceInProgress
        service {
          name
        }
      }
    }
  }
`

export const BULK_DELETE_SERVICE_SCHEDULES = gql`
  mutation DeleteServiceSchedules($input: DeleteServiceSchedulesInput!) {
    deleteServiceSchedules(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      deleteServiceSchedules {
        serviceId
        status
        forceInProgress
        service {
          name
        }
      }
    }
  }
`

export const DELETE_SERVICE_SCHEDULE = gql`
  mutation DeleteServiceSchedule($input: DeleteServiceScheduleInput!) {
    deleteServiceSchedule(input: $input) {
      isSuccessful
      message
      status
      deleteServiceSchedule {
        forceInProgress
        status
        serviceId
        ssgroupId
        vehicleId
        intervalDistance
        intervalTime
        intervalPeriod
        reminderDistance
        reminderTime
        reminderPeriod
        lastServiceDistance
        lastServiceTime
        method
        startServiceAtDistance
        startServiceAtTime
        service {
          name
          serviceAction {
            action
            serviceActionId
          }
          serviceCategory {
            name
            serviceCategoryId
          }
        }
        vehicle {
          id
          imei
          licensePlate
          odometer
          vehicleType {
            category
            manufacturer
            model
            type
          }
        }
      }
    }
  }
`

export const IMPORT_SERVICE_SCHEDULE = gql`
  mutation ImportServiceSchedules($input: ImportFileInput!) {
    importServiceSchedules(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      importServiceSchedules {
        totalData
        totalSuccess
        totalFailed
        originalFile
        successFile
        errorFile
        data {
          sheet1 {
            status
            licensePlate {
              value
              error
            }
            serviceComponent {
              value
              error
            }
            serviceActivity {
              value
              error
            }
            serviceCategory {
              value
              error
            }
            startServiceAtDistance {
              value
              error
            }
            startServiceAtTime {
              value
              error
            }
            serviceIntervalDistance {
              value
              error
            }
            serviceReminderDistance {
              value
              error
            }
            serviceIntervalTime {
              value
              error
            }
            serviceIntervalTimePeriod {
              value
              error
            }
            serviceReminderTime {
              value
              error
            }
            serviceReminderTimePeriod {
              value
              error
            }
            serviceMethod {
              value
              error
            }
          }
          sheet2 {
            status
            licensePlate {
              value
              error
            }
            serviceComponent {
              value
              error
            }
            serviceActivity {
              value
              error
            }
            serviceCategory {
              value
              error
            }
            startServiceAtHourmeter {
              value
              error
            }
            serviceIntervalHourmeter {
              value
              error
            }
            serviceReminderHourmeter {
              value
              error
            }
            serviceMethod {
              value
              error
            }
          }
          sheet3 {
            status
            licensePlate {
              value
              error
            }
            serviceComponent {
              value
              error
            }
            serviceActivity {
              value
              error
            }
            serviceCategory {
              value
              error
            }
            startServiceAtRefrigerator {
              value
              error
            }
            serviceIntervalRefrigerator {
              value
              error
            }
            serviceReminderRefrigerator {
              value
              error
            }
            serviceMethod {
              value
              error
            }
          }
        }
      }
    }
  }
`

export const GET_SERVICE_SCHEDULE_GROUP = gql`
  query Ssgroups($filter: SsgroupsFilter) {
    ssgroups(filter: $filter) {
      isSuccessful
      message
      ssgroups {
        data {
          ssgroupId
          companyId
          name
          service2Ssgroup {
            serviceId
            service {
              companyId
              serviceId
              name
              serviceActionId
              serviceCategoryId
              serviceAction {
                action
              }
              serviceCategory {
                name
              }
            }
            ssgroupId
            intervalDistance
            reminderDistance
            intervalTime
            intervalPeriod
            reminderTime
            reminderPeriod
            intervalHourmeter
            reminderHourmeter
            type
            method
          }
          vehicles {
            id
            imei
            licensePlate
            vehicleType {
              manufacturer
              model
              type
              category
              icon
            }
          }
        }
        pagination {
          total
          page
          show
        }
      }
      status
    }
  }
`

export const GET_SERVICE_SCHEDULE_GROUP_BY_ID = gql`
  query Ssgroup($filter: SsgroupFilter!) {
    ssgroup(filter: $filter) {
      isSuccessful
      message
      ssgroup {
        ssgroupId
        companyId
        name
        service2Ssgroup {
          serviceId
          service {
            companyId
            serviceId
            name
            serviceActionId
            serviceCategoryId
            serviceAction {
              action
            }
            serviceCategory {
              name
            }
          }
          ssgroupId
          intervalDistance
          reminderDistance
          intervalTime
          intervalPeriod
          reminderTime
          reminderPeriod
          intervalHourmeter
          reminderHourmeter
          intervalRefrigerator
          reminderRefrigerator
          type
          method
        }
        vehicles {
          id
          imei
          licensePlate
          vehicleType {
            model
            type
            category
            manufacturer
            icon
          }
        }
      }
      status
    }
  }
`

export const CREATE_SERVICE_SCHEDULE_GROUP = gql`
  mutation CreateSsgroup($input: CreateSsgroupInput!) {
    createSsgroup(input: $input) {
      isSuccessful
      message
      createSsgroup {
        ssgroupId
        companyId
        name
        service2Ssgroup {
          serviceId
          service {
            name
            serviceActionId
            serviceCategoryId
            serviceAction {
              action
            }
            serviceCategory {
              name
            }
          }
          ssgroupId
          intervalDistance
          reminderDistance
          intervalTime
          intervalPeriod
          reminderTime
          reminderPeriod
          intervalHourmeter
          reminderHourmeter
          method
        }
        vehicles {
          id
          imei
          licensePlate
          vehicleType {
            manufacturer
            model
            type
            category
          }
        }
      }
      status
    }
  }
`

export const UPDATE_SERVICE_SCHEDULE_GROUP = gql`
  mutation UpdateSsgroup($input: UpdateSsgroupInput!) {
    updateSsgroup(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      updateSsgroup {
        ssgroupId
        companyId
        name
        service2Ssgroup {
          serviceId
          service {
            name
            serviceAction {
              action
            }
            serviceActionId
            serviceCategoryId
            serviceCategory {
              name
            }
          }
          ssgroupId
          intervalDistance
          reminderDistance
          intervalTime
          intervalPeriod
          reminderTime
          reminderPeriod
          intervalHourmeter
          reminderHourmeter
          method
        }
        vehicles {
          id
          imei
          licensePlate
          vehicleType {
            manufacturer
            model
            type
            category
          }
        }
      }
      status
    }
  }
`

export const DELETE_SERVICE_SCHEDULE_GROUP = gql`
  mutation DeleteSsgroup($input: DeleteSsgroupInput!) {
    deleteSsgroup(input: $input) {
      isSuccessful
      message
      errorCode
      errorName
      deleteSsgroup {
        ssgroupId
        companyId
        name
        service2Ssgroup {
          serviceId
        }
        vehicles {
          id
        }
      }
      status
    }
  }
`

export const IMPORT_SERVICE_SETTING = gql`
  mutation ImportServiceSetting($input: ImportFileInput!) {
    importServiceSetting(input: $input) {
      isSuccessful
      message
      status
      errorCode
      errorName
      importServiceSetting {
        totalSuccess
        totalFailed
        totalData
        errorFile
      }
    }
  }
`

export const DETACH_SERVICE_SCHEDULE_GROUP = gql`
  mutation DetachVehicle2Ssgroup($input: DetachVehicle2SsgroupInput!) {
    detachVehicle2Ssgroup(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      detachVehicle2Ssgroup {
        serviceId
        ssgroupId
        vehicleId
        ssgroup {
          ssgroupId
          companyId
          name
        }
      }
    }
  }
`
